<template>
  <div>
    <h2>Reset all data</h2>
    <p>WARNING: Clicking the button below will delete all data associated with the cover calculator (this action is not reversible)</p>
    <button class="submit-button" @click="submit">Reset Plugin</button>
    <p class="error" v-if="error" v-html="error"></p>
  </div>
</template>

<script>
export default {
  name: "Reset",
  props: {
    base: {
      type: String,
      required: true,
    }
  },
  data(){
    return{
      error: '',
    }
  },
  methods: {
    submit(){
      if (confirm('Are you sure you want to delete all data associated with cover calculator and reset the plugin?')){
        this.$axios.post(`${this.base}/api/reset.php`)
            .then((response) => {
              if (response.data === "complete"){
                this.$emit('save');
              }
              else{
                this.error = response.data;
              }
            });
      }

    }
  }
}
</script>

<style lang="scss" scoped>
form {
  width: 50%;
}

.form-input {
  width: 100%;
  margin: 1rem 0;
  display: block;

  span, input[type=text] {
    width: 100%;
    display: block;
  }

  span {
    margin-bottom: 0.5rem;
  }

  &.half {
    width: 40%;
    margin-right: 5%;
    display: inline-block;
  }
}

.form-checkbox {
  margin: 1rem 1rem 1rem 0;
  display: inline-flex;

  span, input {
    align-self: center;
  }

  span {
    margin-left: 0.4rem;
  }
}

.submit-button {
  display: block;
  margin: 1rem 0;
  background-color: red;
  color: #FFF;
  border-radius: 5px;
  padding: 0.5rem;
  border: none;
  outline: none;
  cursor: pointer;
  transition: 0.2s;

  &:hover {
    background-color: #004885;
    transition: 0.2s;
  }
}

.error {
  color: red;
  margin: 1rem 0;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/Reset.vue